// extracted by mini-css-extract-plugin
export var box = "Input-module--box--ce647";
export var box_md = "Input-module--box_md--4b0d5";
export var box_xmd = "Input-module--box_xmd--33e5f";
export var box_flex = "Input-module--box_flex--8f96b";
export var box_lg = "Input-module--box_lg--b80c7";
export var box_sm = "Input-module--box_sm--10a1c";
export var box_outer = "Input-module--box_outer--c0dd7";
export var box_whiteBg = "Input-module--box_white-bg--5a614";
export var box_noMarginBottom = "Input-module--box_no-margin-bottom--42197";
export var box_noPadding = "Input-module--box_no-padding--6285c";
export var box_outerGray = "Input-module--box_outer-gray--3ddc0";
export var box_dark = "Input-module--box_dark--a02da";
export var box_zIndex = "Input-module--box_z-index--af600";
export var box_zIndex6 = "Input-module--box_z-index-6--7fc02";
export var box_eventsWithLine = "Input-module--box_events-with-line--091ca";
export var box_featuresAo = "Input-module--box_features-ao--71169";
export var box_verticalPaddings = "Input-module--box_vertical-paddings--4b889";
export var clearP = "Input-module--clearP--40db6";
export var clearP_vc = "Input-module--clearP_vc--a5afe";
export var label = "Input-module--label--f2227";
export var textAreaWrapper = "Input-module--textAreaWrapper--ad4cb";
export var prependedTooltip = "Input-module--prependedTooltip--e8751";
export var prependedIcon = "Input-module--prependedIcon--01038";
export var error = "Input-module--error--b9de0";
export var placeholder = "Input-module--placeholder--1e5cf";
export var withPrependedTooltip = "Input-module--withPrependedTooltip--c5933";
export var scrollbarShow = "Input-module--scrollbarShow--357df";
export var closeButton = "Input-module--closeButton--dfee1";
export var tooltip = "Input-module--tooltip--19054";
export var fadeInAnimation = "Input-module--fadeInAnimation--15950";
export var placeHolderShimmer = "Input-module--placeHolderShimmer--af8c5";